// extracted by mini-css-extract-plugin
export var carrierIcon = "_xw-0";
export var carrierLogo = "_xw-1";
export var detailsSection = "_xw-2";